import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import { useNavigate } from 'react-router-dom'

import { StyledContentTableCell, StyledTableRow } from 'shared/components/StyledTableComponents'
import { StyledTableHeadCell } from 'views/Authorized/views/ErpProductCard/styles'
import ContainedButton from 'shared/components/Buttons/ContainedButton'

import { Product } from '../../types'

interface Props {
   categories: PropType<Product, 'categories'>
   handleClose: () => void
}
export default function CategoriesDetailsModal({ categories, handleClose }: Props) {
   const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
   const navigate = useNavigate()

   function handleScrollClick(productUuid: string) {
      const urlStart = window.location.href.split('/')[0]
      const url = `${urlStart}/dashboard/product?uuid=${productUuid}`
      return window.open(url, '_blank')
   }

   return (
      <Dialog maxWidth="md" onClose={handleClose} open={!!categories}>
         <DialogTitle color="primary"> Szczegóły dotyczące kategorii</DialogTitle>
         <DialogContent>
            <Table>
               <TableHead>
                  <TableRow sx={{ backgroundColor: 'rgba(33,147,224,0.1)' }}>
                     <StyledTableHeadCell>Źródło</StyledTableHeadCell>
                     <StyledTableHeadCell>Nazwa kategorii</StyledTableHeadCell>
                     {/* <StyledTableHeadCell>Tłumaczenie pl</StyledTableHeadCell>
                     <StyledTableHeadCell>Tłumaczenie en</StyledTableHeadCell>
                     <StyledTableHeadCell>Tłumaczenie de</StyledTableHeadCell> */}
                  </TableRow>
               </TableHead>
               <TableBody>
                  {categories?.map((item) => (
                     <StyledTableRow key={item.uuid}>
                        <StyledContentTableCell
                           onClick={() => {
                              if (uuidRegex.test(item.source)) {
                                 navigate(`/dashboard/product?uuid=${item.source}`)
                              }
                           }}
                           onMouseDown={(e) => {
                              if (uuidRegex.test(item.source)) {
                                 if (e.button === 1) handleScrollClick(item.source)
                              }
                           }}
                           sx={(theme) => ({
                              fontWeight: 'bold',
                              ...(uuidRegex.test(item.source) && {
                                 '&:hover': {
                                    color: theme.palette.primary.light,
                                    cursor: 'pointer',
                                 },
                              }),
                           })}
                        >
                           {item.source}
                        </StyledContentTableCell>
                        <StyledContentTableCell>{item.sourceValue}</StyledContentTableCell>
                        {/* <StyledContentTableCell>{item.translations.pl_pl ?? 'BRAK'}</StyledContentTableCell>
                        <StyledContentTableCell>{item.translations.en_en ?? 'BRAK'}</StyledContentTableCell>
                        <StyledContentTableCell>{item.translations.de_de ?? 'BRAK'}</StyledContentTableCell> */}
                     </StyledTableRow>
                  ))}
               </TableBody>
            </Table>
         </DialogContent>
         <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <ContainedButton variant="contained" onClick={handleClose}>
               Zamknij
            </ContainedButton>
         </DialogActions>
      </Dialog>
   )
}
